import { readUsers } from './read'
import { readUser } from './readSingle'
import { resourceObject } from './resourceObject'

export const users = {
  readCollection: readUsers,
  readSingle: readUser,
  resourceObject,
}
